<template>
	<v-footer class="white--text footer--sheet pt-8">
		<v-container>
			<v-row v-show="footer?.links !== false" class="mb-6">
				<v-col cols="12" md="3">
					<ul class="ul--footer pl-0 white--text">
						<p>
							Air Club
						</p>
						<li>
							<router-link class="white--text" to="/air-club">
								About Air Club
							</router-link>
						</li>
						<li>
							<router-link class="white--text" to="/marketing">
								Marketing
							</router-link>
						</li>
						<li>
							<router-link class="white--text" to="/product-updates">
								Product Updates
							</router-link>
						</li>
						<li>
							<router-link class="white--text" to="/air-mail">
								Air Mail
							</router-link>
						</li>
					</ul>
				</v-col>
				<v-col cols="12" md="3">
					<ul class="ul--footer pl-0 white--text">
						<p>
							Air Solutions
						</p>
						<li>
							<router-link class="white--text" to="/sourcing">
								Air Sourcing
							</router-link>
						</li>
						<li>
							<router-link class="white--text" to="/sourcing/#writeroute">
								WriteRoute
							</router-link>
						</li>
						<li>
							<router-link class="white--text" to="/navigator">
								Navigator
							</router-link>
						</li>
						<li class="d-none">
							<router-link class="white--text" to="/sourcing">
								Mobile App
							</router-link>
						</li>
					</ul>
				</v-col>
				<v-col cols="12" md="3">
					<ul class="ul--footer pl-0 white--text">
						<p>
							Air Academy
						</p>
						<li>
							<router-link class="white--text" to="/air-academy">
								About Air Academy
							</router-link>
						</li>
						<li>
							<router-link class="white--text" to="/insights-hub">
								Insights Hub
							</router-link>
						</li>
					</ul>
				</v-col>
				<v-col cols="12" md="3">
					<ul class="ul--footer pl-0 white--text">
						<p>
							Get Involved
						</p>
						<li>
							<router-link class="white--text" to="/advisers">
								Log in
							</router-link>
						</li>
						<li>
							<router-link class="white--text" to="/register">
								Register
							</router-link>
						</li>
						<li>
							<router-link class="white--text" to="/news">
								News
							</router-link>
						</li>
						<li>
							<router-link class="white--text" to="/events">
								Events
							</router-link>
						</li>
					</ul>
				</v-col>
			</v-row>

			<v-divider v-show="footer?.links !== false" class="my-6" dark />

			<v-row>
				<v-col class="shrink">
					<img class="d-block" :src="'manager_documents/c86e4548-50f9-4c76-8a80-00db9378724b.svg' | urlize" width="130px" alt="" />
				</v-col>
				<v-col class="pl-10 grow align-content-center">
					<p class="text-h4 font-weight-bold mb-2">
						<a class="white--text" href="tel:08002945097">
							0800 294 5097
						</a>
					</p>
					<p class="text-body-1 font-weight-bold mb-0">
						Southgate House, Southgate Street
						Gloucester, Gloucestershire
						United Kingdom
						GL1 1UD
					</p>
				</v-col>
			</v-row>

			<v-divider class="my-6" dark />

			<v-row class="white--text">
				<v-col cols="12" md="8">
					<p class="text-caption plain mb-2">
						This site is for professional adviser use only and has not been approved for use with consumers. Air is a Trading Style of Answers in Retirement Limited.
						Answers in Retirement Limited is a Limited Company registered in England and Wales number: 09991416. Southgate House, Southgate Street, Gloucester,
						Gloucestershire, United Kingdom, GL1 1UD.
					</p>
					<ul class="ul--horizontal text-caption plain pl-0 mb-2">
						<li>
							<a class="white--text" @click="openSlaveryStatement">Modern Slavery Statement</a>
						</li>
						<li>
							<a class="white--text" @click="openTerms">Terms and Conditions</a>
						</li>
						<li>
							<a class="white--text" @click="openPrivacy">Privacy Notice</a>
						</li>
					</ul>
					<p class="text-caption plain mb-0">
						Copyright © All Rights Reserved
					</p>
				</v-col>
				<v-col cols="12" md="4" class="justify-items-end">
					<!-- Social -->
					<ul class="ul--social pl-0">
						<li>
							<a href="https://www.facebook.com/share/VwuTKueZMPkVJHsj/" target="_blank" rel="noopener noreferrer">
								<v-icon size="24" class="white--text">mdi-facebook</v-icon>
							</a>
						</li>
						<li>
							<a href="https://twitter.com/air_laterlife" target="_blank" rel="noopener noreferrer">
								<v-icon size="24" class="white--text">mdi-twitter</v-icon>
							</a>
						</li>
						<li>
							<a href="https://www.linkedin.com/company/airlaterlife/" target="_blank" rel="noopener noreferrer">
								<v-icon size="24" class="white--text">mdi-linkedin</v-icon>
							</a>
						</li>
					</ul>
				</v-col>
			</v-row>
		</v-container>
	</v-footer>
</template>

<script>
	import { EventBus } from '@/utils';
	import { mapState } from 'vuex';

	export default {
		name: 'app-layout-default-footer',

		computed: {
            ...mapState('Layout', ['footer'])
        },

		methods: {
			openTerms() {
				EventBus.$emit('open-terms');
			},

			openPrivacy() {
				EventBus.$emit('open-privacy');
			},

			openSlaveryStatement() {
				EventBus.$emit('open-slavery-statement');
			}
		}
	};
</script>

<style lang="scss" scoped>
    .footer--sheet {
		border-top: 1px solid #FFFFFF11;
        background-color: var(--v-newUiPurple-base);

		ul.ul--footer {
			margin: -8px 0;

			p {
				margin: 8px 0 16px;
				font-size: 1.1rem;
				line-height: 1.2rem;
				font-weight: 500;
				color: var(--v-newUiGreen-base);
			}

			li {
				margin: 8px 0;
				font-size: 1.0rem;
				line-height: 1.2rem;
				font-weight: 400;
				list-style: none;
			}
		}

		ul.ul--main {
			margin: -8px 0;
			display: flex;
			flex-flow: row wrap;

			li {
				display: flex;
				flex-direction: row;
				flex-basis: 33%;
				flex-grow: 1;
				margin: 8px 0;
				font-size: 1.0rem;
				line-height: 1.2rem;
				font-weight: 400;
				list-style: none;
			}
		}

		ul.ul--horizontal {
			margin: 0 -8px;

			li {
				display: inline;
				margin: 0 8px;

				a {
					text-decoration: underline;
				}
			}
		}

		ul.ul--social {
			margin: 0 -8px;

			li {
				display: inline;
				margin: 0 8px;
			}
		}
    }
</style>